/**
 * Lib which checks whether a path is an URI or not
 */
// RFC 3986:
const URI =
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;

function isURI(path) {
  return URI.test(path);
}

/**
 * Returns whether the app is running on dev environment
 */
export const isDevEnv = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    ) ||
    window.location.hostname.split(".").find((v) => v.indexOf("dev") > -1)
);

export default isURI;
